import React from "react";

import Text from "@src/sharedComponents/Typography/Text";

const HouseholdDocuments = (): JSX.Element => {
  return <Text>HouseholdDocuments</Text>;
};

export default HouseholdDocuments;
